export const facturacion = {
    text1: "Zahlungsart",
    text2: "Kreditkarte",
    text3: "Keine Zahlungsarten hinterlegt",
    text4: "Zahlungsart bearbeiten",
    text5: "Zahlungsart hinzufügen",
    text6: "Eine Zahlungsart hinzufügen",
    text7: "Eine Zahlungsart aktualisieren",
    text8: "Hinterlegen oder aktualisieren Sie die Zahlungsart, über die monatlich abgebucht wird.",
    text9: "Kartennummer:",
    text10: "Gültig bis",
    text11: "CVC",
    text12: "Karte speichern",
    text13: "Ungültige Nummer",
    text14: "Ungültig",
    text15: "Ungültiger CVC.",
    text16: "Da ist etwas schiefgelaufen",
    text17: "Verbrauch",
    text18: "Ausgestellte Rechnungen",
    text19: "Von - Bis",
    text20: "ID",
    text21: "Betrag",
    text22: "Rechnungsaussteller",
    text23: "BIG NERDS COMPANY L.L.C.",
    text24: "Ausstellungsdatum",
    text25: "Status",
    text26: "Rechnung herunterladen",
    text27: "Rechnung wird erstellt ...",
    text28: "Fast fertig, bitte warten...",
    text29: "Wird geladen ...",
    text30: "Die Rechnung konnte leider nicht erstellt werden",
    text31: "Möchten Sie die Zahlungsart wirklich löschen?",
    text32: "Ihre gespeicherten Daten gehen verloren",
    text33: "Zahlungsart löschen",
    text34: "Abbrechen",

    // Corrections
    p1: "Abonnement",
    p2: "Ihr Abonnement",
    p3: "KOSTENLOS",
    p4: "INDIVIDUELL",
    p5: "Sie haben kein aktives Abonnement. Ändern wir das!",
    p6: "Läuft ab:",
    p7: "Plan wählen",
    p8: "Upgrade",
    p9: "Anzahl der Unterkünfte",
    p10: "Pro Unterkunft",
    p11: "Abonnement verwalten",
    p12: "Zahlungseinstellungen",
    p13: "Läuft ab:",
    p14: "Bearbeiten",
    p15: "Automatische Verlängerung",
    p16: "Aktiviert",
    p17: "Die nächste Zahlung ist geplant für",
    p18: "Rechnungen und Belege",
    p19: "INDIVIDUELL",
    p20: "Rechnung ansehen",
    p21: "Rechnung herunterladen",
    p22: "für",

    p23: "Monatlich",
    p24: "Jährlich",
    p25: "Wir schenken Ihnen 2 Monate.",
    p26: "Art des Abonnements",


    p27: "Ferienwohnung",
    p28: "Hotel - Hostel",
    p29: "Campingplatz",
    p30: "Villa",


    p31: `Die "<strong>Unterkunft</strong>" bezieht sich auf einzelne Häuser oder Wohnungen. Beim "<strong>Aparthotel</strong>" zählt jede Wohnung als eigene Unterkunft`,
    p32: `Gezählt wird nach
    <strong>Zimmern</strong> bei Hotels, nach Betten bei Hostels
    und nach <strong>Personen </strong> bei Campingplätzen.

    <br />
    <strong>Beispiel:</strong> Ein Hostel mit 4 Zimmern und 20 Betten zählt als
    20 Unterkunftseinheiten`,

    p33: `PREMIUM`,
    p34: `Monat`,
    p35: `Zimmer`,
    p36: `Apartment`,
    p37: `Details zum Plan`,
    p38: `Check-in vor Ort per QR`,
    p39: `Check-in über vorab gesendeten Link`,
    p40: `Willkommensnachricht per E-Mail`,
    p41: `Biometrische Unterschrift der Hausordnung`,
    p42: `Scanner für Ausweis und Reisepass`,
    p43: `Unbegrenzter Cloud-Speicher`,
    p44: `Cross-Selling-Shop`,
    p45: `Automatische Meldung an die Behörden`,
    p46: `Synchronisierung der Buchungen mit dem PSM`,
    p47: `Abonnement aktualisieren`,
    p48: `Weiter`,
    p49: `pro`,

    p50: `Zusätzliche Leistungen für Ihren Plan auswählen`,
    p51: `Empfohlen`,
    p52: `WhatsApp`,
    p53: `Wir laden Ihre Gäste per WhatsApp zum Check-in ein, geplant vor ihrer Ankunft in Ihrer Unterkunft.`,
    p54: `Apartment`,
    p55: `Villa`,
    p56: `Stellplatz`,
    p57: `Zimmer`,
    p58: `Unterschied bei der Nutzung von WhatsApp`,
    p59: `Unser WhatsApp nutzen`,
    p60: `Wenn Sie unseren WhatsApp-Dienst nutzen, erscheint als Absender der Nachrichten an Ihre Gäste WACheckin. Wir kümmern uns um die Verwaltung der Nachrichten, damit die Kommunikation mit Ihren Gästen reibungslos läuft.`,
    p61: `Wenn Sie unseren Dienst mit Ihrer eigenen WhatsApp-Nummer nutzen, erscheint Ihr WhatsApp-Name als Absender und Sie können Ihr Verifizierungsabzeichen führen. Die Versandkosten richten sich nach Ihrem Verbrauch bei WhatsApp Business mit Meta.`,
    p62: `Ihr WhatsApp Business nutzen`,
    p63: `Bewertungen`,
    p64: `Nutzen Sie die Gelegenheit, das Erlebnis Ihrer Gäste zu verbessern und mehr positive Bewertungen zu sammeln!`,
    p65: `Vorteile`,
    p66: `Nach dem Check-out senden wir Ihren Gästen per WhatsApp eine Bewertungsumfrage, was den Online-Ruf Ihrer Unterkunft deutlich stärkt. Unser Dienst ist darauf ausgelegt, Ihre positiven Bewertungen zu steigern.`,
    p67: `Fernzugang`,
    p68: `Wir senden Ihren Gästen einen virtuellen Schlüssel für den selbstständigen Zugang zur Unterkunft.`,
    p69: `Vorteile`,
    p70: `Ihre Gäste erhalten die Zugangsschlüssel zum Zimmer sicher und bequem, sobald sie den Check-in abgeschlossen haben. Das sorgt für ein unkompliziertes Erlebnis und macht die Zugangsverwaltung effizienter.`,
    p71: `Identitätsprüfung`,
    p72: `Wir prüfen die Identität Ihrer Gäste mit unserer Software für den biometrischen Abgleich.`,
    p73: `Vorteile`,
    p74: `Wir prüfen die Identität Ihrer Gäste mit unserer Software für den biometrischen Abgleich und stellen so sicher, dass die Dokumente zu der Person passen, die Ihre Unterkunft betritt.`,
    p75: `Jetzt abonnieren`,
    p76: `Unbegrenzter Cloud-Speicher`,
    p77: `Individuell`,
    p78: `Fragen Sie unser Vertriebsteam`,
    p79: `WhatsApp`,
    p80: `Identitätsprüfung`,
    p81: `Bewertungen (Check-in-Bewertungen)`,
    p82: `Anbindung per API an smarte Schlösser`,
    p83: `Kartenzahlung (für Kautionen, Leistungen usw.)`,
    p84: `Mit dem Vertrieb sprechen`,
    p85: ``,
    p86: ``,
    p87: ``,
    p88: ``,
    p89: ``,






};
